export const listStatus = [
  { textStatus: 'Procesada', valueStatus: 'W' },
  { textStatus: 'Pendiente por procesar', valueStatus: 'P' },
  { textStatus: 'Rechazadas', valueStatus: 'E' },
  { textStatus: 'Gestionado - Sin Fiscalizar', valueStatus: 'G' },
]


export const representation = [
  { textRepresentation: 'Standard', valueRepresentation: 'Standard' },
  { textRepresentation: 'Plus', valueRepresentation: 'Plus' },
]
